import { mkdtempSync, PathLike, rmSync, writeFileSync } from "fs";
import { tmpdir } from "os";
import { resolve } from "path";

export type FileSizeUnit = "GB" | "MB";

export class FileSize {
  size: number;
  unit: FileSizeUnit;
}

export class FileHelper {
  static createTmpDirectoryPath(): string {
    return mkdtempSync(this.tmpFilepath());
  }

  static tmpFilepath(): string {
    return resolve(tmpdir(), `tmp-${process.pid}-${Math.random()}-${Math.random()}`);
  }

  static readableFileSize(kb: number, opts?: { decimalPlaces: number }): FileSize {
    const decimalPlaces = 10 ** (opts?.decimalPlaces || 1);
    const isGB = kb >= 1000 * 1000;
    const size = Math.floor((kb / 1000 / (isGB ? 1000 : 1)) * decimalPlaces) / decimalPlaces;
    const unit = isGB ? "GB" : "MB";

    return { size, unit };
  }

  static getFileExtensionFromFilename(filename: string): string {
    const arr = filename.split(".");

    return arr[arr.length - 1];
  }

  static getFileNameWithoutExtension(filename: string): string {
    const lastDotIndex = filename.lastIndexOf(".");

    return lastDotIndex === -1 ? filename : filename.slice(0, lastDotIndex);
  }

  static writeFile(path: number | PathLike, data: string | NodeJS.ArrayBufferView): boolean {
    try {
      writeFileSync(path, data);

      return true;
    } catch (e) {
      if (e instanceof Error) {
        // ...
      }

      throw e;
    }
  }

  static removeTmpPath(paths: string[]): boolean {
    for (const path of paths) {
      try {
        rmSync(path, { recursive: true });
      } catch (e) {
        if (e instanceof Error) {
          // ...
        }

        throw e;
      }
    }

    return true;
  }
}
